import { useRequest } from 'ahooks';
import http from '@/utils/http';
import { RequrstBack, } from '@/pages/aigc/types/server';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
// 获取业务游戏
export const useGetLangMap = (lang: string) => {
  const fetch = (mutateParams: any) =>
    http({
      url: `/api/v1/ai/get_lang_map?lang=${lang}`,
      method: 'get',
      data: {},
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [lang],
    cacheKey: 'langMap',
    loadingDelay: 300,
  });
  return {
    ...data,
  };
};
// 获取翻译语言
export const useGetToTranslate = <T,>(params?: T,) => {
  const fetch = (mutateParams: T) =>
    http({
      url: 'api/v1/ai/to_translate',
      method: 'post',
      data: mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'toTranslate',
    loadingDelay: 300,
    manual: true
  });
  return {
    ...data,
  };
};